import { render } from "./Galerie.vue?vue&type=template&id=a8748ff0"
import script from "./Galerie.vue?vue&type=script&lang=js"
export * from "./Galerie.vue?vue&type=script&lang=js"

import "./Galerie.vue?vue&type=style&index=0&id=a8748ff0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__